import { FORM_FAILURE,FORM_SUCCESS, FORM_REQUEST } from "../constants/ActionTypes";

const initialState = {
    loading : true,
    saveForm :[],
    error : '',
}
export default function registrationFormsReducer(state = initialState ,action){
    switch(action.type){
        case FORM_REQUEST : return{
            ...state,
            loading:true
        }
        case FORM_SUCCESS : return {
            ...state,
saveForm : action.data,
            loading:false

        }
        case FORM_FAILURE :
            
        return {
            ...state,
            error :action.errors.message,
            loading :false 
        }
        default : return  state;
        
    } 

}